import React, { Suspense } from 'react';

const App = React.lazy(() => import('./App'));

export default function LazyApp() {
  return (
    <Suspense fallback={<div />}>
      <App />
    </Suspense>
  );
}
